import { useEffect, useState } from "react";
import { UserPlus } from "@phosphor-icons/react";
import client from "../lib/api";

const origin = (s) => {
  const ch = (s.utm_source || "").toLowerCase();
  const parts = [];
  if (ch === "reels_page" || ch === "reels") {
    parts.push(`Reel${s.utm_content ? `: ${s.utm_content}` : "s page"}`);
  } else if (ch) {
    parts.push(ch.charAt(0).toUpperCase() + ch.slice(1) + (s.utm_content ? ` · ${s.utm_content}` : ""));
  }
  if (s.landing_path) parts.push(`landed on ${s.landing_path.split("?")[0]}`);
  if (!parts.length && s.referrer) {
    try { parts.push(`via ${new URL(s.referrer).hostname}`); } catch { parts.push("via external link"); }
  }
  return parts.length ? parts.join(" · ") : "Direct";
};

const ago = (iso) => {
  const h = (Date.now() - new Date(iso).getTime()) / 36e5;
  if (h < 1) return "just now";
  if (h < 24) return `${Math.round(h)}h ago`;
  return `${Math.round(h / 24)}d ago`;
};

export const SignupSourcesCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    client.get("/admin/signup-sources").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.signups?.length) return null;

  return (
    <div className="mt-6 card-surface p-4" data-testid="signup-sources-card">
      <div className="flex items-center gap-2 mb-3">
        <UserPlus size={14} weight="bold" color="#FF9764" />
        <span className="overline">NEW SIGNUPS · WHERE THEY CAME FROM · LAST 30 DAYS</span>
        <span className="ml-auto text-[10px] font-mono text-neutral-400">{data.total} signups</span>
      </div>
      <div className="space-y-1.5">
        {data.signups.map((s) => (
          <div key={s.email} data-testid={`signup-source-row-${s.email}`}
               className="flex items-center gap-3 rounded-lg bg-white/[0.03] px-3 py-2">
            <div className="min-w-0 flex-1">
              <span className="text-[12px] font-bold text-white truncate">{s.company_name || s.full_name || s.email}</span>
              <span className="ml-2 text-[10px] text-neutral-500">{s.full_name}</span>
            </div>
            <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-[10px] font-mono border ${
              s.utm_source
                ? "border-[#FF5A1F]/40 bg-[#FF5A1F]/10 text-[#FF9764]"
                : "border-white/10 bg-white/[0.04] text-neutral-400"
            }`}>
              {origin(s)}
            </span>
            <span className="shrink-0 w-16 text-right text-[10px] font-mono text-neutral-500">{ago(s.created_at)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
